
export class Status {
    displayValue: string;
    value: number;
    displayClass: string;
    /** Optional key used by the API (e.g. backend enum name). Used for audit/history lookup when API sends "ToPick" but displayValue is "To pick". */
    apiKey?: string;

    constructor(displayValue: string, value: number, displayColour: string, apiKey?: string) {
        this.displayValue = displayValue;
        this.value = value;
        this.displayClass = displayColour;
        this.apiKey = apiKey;
    }
}

// Generic function to lookup Status by value
export function getStatusByValue<T extends object>(statusClass: T, value: number): Status | undefined {
    const statuses = Object.values(statusClass);
    const match = statuses.find((status: Status) => status.value === value) as Status | undefined;
    return match;
}

export function isStatusDto(obj: any): obj is StatusDto {
    return obj && typeof obj.value === "number" && typeof obj.typeName === "string";
}

export class StatusDto {
    value: number;
    typeName: string;

    constructor(value: number, typeName: string) {
        this.value = value;
        this.typeName = typeName;
    }
}